angular.module('lsnBase.deprecated.models')
  .factory('RiskVariantModel', ['LsnRiskVariantModelV1',
    function(LsnRiskVariantModelV1) {
      return LsnRiskVariantModelV1;
    }
  ]);